<template>
  <div>
    <!--统计卡片-->
    <Row type="flex" :space-x="16" class="margin-right-left padding-top">
      <Cell v-for="card in cards" :key="card.key" :flex="1">
        <div class="stat-card" :class="card.cls">
          <div class="stat-value">{{ card.value }}</div>
          <div class="stat-title">{{ card.title }}</div>
        </div>
      </Cell>
    </Row>

    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <input type="text" v-model="params.keyword" v-width="200" placeholder="账套名称/税号"
               @keyup.enter="doSearch">
      </Cell>
      <Cell>
        <DatePicker type="month" v-model="params.period" format="YYYY-MM" style="width: 140px"
                    placeholder="所属期"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="green" @click="rapidDeclare">一键申报</Button>
        <Button @click="showTip('获取申报信息')">获取申报信息</Button>
        <Button @click="openTaxAccount">税务账号设置</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="dataList" :border="true" :loading="loading">
        <TableItem title="财税项目" prop="taxItem" :width="150"></TableItem>
        <TableItem title="申报信息" prop="declareInfo" :width="160"></TableItem>
        <TableItem title="所属期起" prop="periodStart" :width="110"></TableItem>
        <TableItem title="所属期止" prop="periodEnd" :width="110"></TableItem>
        <TableItem title="申报期限" prop="declareDeadline" :width="110"></TableItem>
        <TableItem title="申报状态" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="data.declareStatus === 2 ? 'h-tag-bg-green' : 'h-tag-bg-yellow'">
              {{ declareStatusText(data.declareStatus) }}
            </span>
          </template>
        </TableItem>
        <TableItem title="缴款状态" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="data.payStatus === 2 ? 'h-tag-bg-green' : 'h-tag-bg-yellow'">
              {{ payStatusText(data.payStatus) }}
            </span>
          </template>
        </TableItem>
        <TableItem title="应补退税额" :width="120" align="right">
          <template slot-scope="{data}">{{ data.taxAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="申报时间" prop="declareTime" :width="150"></TableItem>
        <TableItem title="申报截图" :width="90" align="center">
          <div class="actions" slot-scope="scope">
            <span @click="showTip('申报截图')">查看</span>
          </div>
        </TableItem>
        <TableItem title="缴款截图" :width="90" align="center">
          <div class="actions" slot-scope="scope">
            <span @click="showTip('缴款截图')">查看</span>
          </div>
        </TableItem>
        <TableItem title="操作" :width="130">
          <div class="actions" slot-scope="{data}">
            <span @click="markDeclare(data)" v-if="data.declareStatus !== 2">标记申报</span>
            <span @click="markPay(data)" v-else-if="data.payStatus !== 2">标记缴款</span>
            <span @click="edit(data)">编辑</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <!--标记/编辑弹窗-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">申报标记</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="财税项目">
          <input type="text" v-model="form.taxItem" disabled>
        </FormItem>
        <FormItem label="申报状态" prop="declareStatus">
          <Select v-model="form.declareStatus" :datas="declareStatusList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="申报时间">
          <DatePicker type="datetime" v-model="form.declareTime" format="YYYY-MM-DD HH:mm"></DatePicker>
        </FormItem>
        <FormItem label="缴款状态" prop="payStatus">
          <Select v-model="form.payStatus" :datas="payStatusList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="缴款时间">
          <DatePicker type="datetime" v-model="form.payTime" format="YYYY-MM-DD HH:mm"></DatePicker>
        </FormItem>
        <FormItem label="应补退税额">
          <NumberInput v-model="form.taxAmount"></NumberInput>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>

    <!--税务账号设置-->
    <Modal v-model="showTaxAccount" hasCloseIcon>
      <div slot="header">税务账号设置</div>
      <Form v-width="380" :labelWidth="100">
        <FormItem label="纳税人识别号">
          <input type="text" v-model="taxAccount.taxNo" placeholder="请输入纳税人识别号">
        </FormItem>
        <FormItem label="税务局账号">
          <input type="text" v-model="taxAccount.account" placeholder="请输入税务局账号">
        </FormItem>
        <FormItem label="密码">
          <input type="password" v-model="taxAccount.password" placeholder="不修改请留空">
        </FormItem>
        <FormItem label="办税人">
          <input type="text" v-model="taxAccount.operator" placeholder="请输入办税人">
        </FormItem>
        <FormItem label="手机号">
          <input type="text" v-model="taxAccount.phone" placeholder="请输入手机号">
        </FormItem>
      </Form>
      <div class="h-text-warning" style="line-height: 22px;">
        <i class="h-icon-info"></i> 账号保存在服务端（密码不回显），接入电子税局开放平台后用于自动申报
      </div>
      <div class="text-center margin-top">
        <Button color="green" @click="saveTaxAccount" :loading="loading">保存</Button>
        <Button @click="showTaxAccount=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex';

export default {
  name: 'DeclareInfo',
  data() {
    return {
      dataList: [],
      summary: {
        total: 0,
        declared: 0,
        paid: 0,
        taxAmount: 0
      },
      declareStatusList: [
        {id: 0, name: '未申报'},
        {id: 1, name: '申报中'},
        {id: 2, name: '已申报'}
      ],
      payStatusList: [
        {id: 0, name: '未缴款'},
        {id: 1, name: '缴款中'},
        {id: 2, name: '已缴款'}
      ],
      params: {
        keyword: '',
        period: moment().format('YYYY-MM')
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      form: {},
      validationRules: {
        required: ['declareStatus', 'payStatus']
      },
      showForm: false,
      showTaxAccount: false,
      taxAccount: {
        taxNo: '',
        account: '',
        password: '',
        operator: '',
        phone: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    cards() {
      return [
        {key: 'total', title: '总税种', value: this.summary.total || 0, cls: 'stat-blue'},
        {key: 'declared', title: '已申报', value: this.summary.declaredCount || 0, cls: 'stat-green'},
        {key: 'paid', title: '已缴款', value: this.summary.paidCount || 0, cls: 'stat-cyan'},
        {key: 'taxAmount', title: '应补税额', value: this.formatMoney(this.summary.taxAmountTotal), cls: 'stat-orange'}
      ];
    }
  },
  methods: {
    formatMoney(val) {
      let num = Number(val) || 0;
      return num.toFixed(2);
    },
    declareStatusText(status) {
      let item = this.declareStatusList.find(val => val.id === status);
      return item ? item.name : '未申报';
    },
    payStatusText(status) {
      let item = this.payStatusList.find(val => val.id === status);
      return item ? item.name : '未缴款';
    },
    showTip(name) {
      this.$Message(`「${name}」需要配置电子税局账号，请先在税务账号设置中完成配置~`);
    },
    queryParams() {
      return Object.assign({}, this.params, {
        page: this.pagination.page,
        size: this.pagination.size
      });
    },
    loadList() {
      this.loading = true;
      this.$api.tax.declare.list(this.queryParams()).then(({data}) => {
        this.dataList = data.results || data.records || data || [];
        this.pagination.total = data.total || 0;
      }).catch(() => {
        this.$Message.error('申报信息加载失败');
      }).finally(() => this.loading = false);
    },
    loadSummary() {
      this.$api.tax.declare.summary(this.params).then(({data}) => {
        this.summary = Object.assign(this.summary, data || {});
      }).catch(() => {
      });
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
      this.loadSummary();
    },
    currentChange() {
      this.loadList();
    },
    rapidDeclare() {
      let ids = this.dataList.filter(item => item.declareStatus !== 2).map(item => item.id);
      this.loading = true;
      this.$api.tax.cloud.rapidDeclare(ids).then(() => {
        this.$Message('申报已提交，请稍后查看申报状态~');
        this.loadList();
        this.loadSummary();
      }).catch((err) => {
        this.$Message.error((err && err.msg) || '一键申报失败');
      }).finally(() => this.loading = false);
    },
    openTaxAccount() {
      this.taxAccount = {taxNo: '', account: '', password: '', operator: '', phone: ''};
      this.$api.tax.account.get().then(({data}) => {
        if (data) {
          this.taxAccount = Object.assign(this.taxAccount, data, {password: ''});
        }
      }).catch(() => {
      }).finally(() => this.showTaxAccount = true);
    },
    saveTaxAccount() {
      this.loading = true;
      this.$api.tax.account.save(this.taxAccount).then(() => {
        this.$Message('税务账号保存成功~');
        this.showTaxAccount = false;
      }).catch((err) => {
        this.$Message.error((err && err.msg) || '税务账号保存失败');
      }).finally(() => this.loading = false);
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    markDeclare(data) {
      this.form = Object.assign({}, data, {
        declareStatus: 2,
        declareTime: moment().format('YYYY-MM-DD HH:mm')
      });
      this.showForm = true;
    },
    markPay(data) {
      this.form = Object.assign({}, data, {
        payStatus: 2,
        payTime: moment().format('YYYY-MM-DD HH:mm')
      });
      this.showForm = true;
    },
    submit() {
      this.loading = true;
      this.$api.tax.declare[this.form.id ? 'update' : 'save'](this.form).then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
        this.loadSummary();
      }).catch(() => {
        this.$Message.error('申报标记保存失败');
      }).finally(() => this.loading = false);
    }
  },
  mounted() {
    this.loadList();
    this.loadSummary();
  }
}
</script>

<style lang="less" scoped>
.stat-card {
  border-radius: 4px;
  padding: 16px 20px;
  color: #fff;

  .stat-value {
    font-size: 26px;
    font-weight: bold;
    line-height: 32px;
  }

  .stat-title {
    font-size: 13px;
    opacity: .9;
    margin-top: 4px;
  }
}

.stat-blue {
  background: #2db7f5;
}

.stat-green {
  background: #19be6b;
}

.stat-cyan {
  background: #17c3b2;
}

.stat-orange {
  background: #ff9900;
}
</style>
